import { Component, ViewChild, TemplateRef, Input, ElementRef, OnInit, OnChanges } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../search-users/search-users.component';
import { from, concatMap, tap, of } from 'rxjs';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tasks-ec-participants',
  templateUrl: './tasks-ec-participants.component.html',
  styleUrls: ['./tasks-ec-participants.component.scss']
})

export class TasksEcParticipantsComponent implements OnInit, OnChanges {

  @Input() effectivenessCheckData: any = {};
  @Input() refresh: boolean;
  isProcessing = false;
  module: any;
  refNo: any;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public qmsservice: qmsService) {
    this.module = this.qmsservice.moduleName;
    this.refNo = this.message.ecMasterDetails.REF_NO;
  }


  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  getQmsTaskECActionsVwDetails: any = [];
  dropDownForActionName: any = [];
  isFrozen: boolean = false;

  findingsList: any = [];
  findingsDropdown: any = [];
  findingSearchText: string = '';
  actionSearchText: string = '';

  ngOnInit() {
    this.isProcessing = true;
    this.isFrozen = this.effectivenessCheckData.showSubTaskButtons;

    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.getcallMethod();
    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.appService.getQmsTaskEcActionVwDetails(this.refNo, this.message.ecMasterDetails.EC_ID).subscribe({
        next:
          (data: any) => {
            this.getQmsTaskECActionsVwDetails = data;
            if (this.getQmsTaskECActionsVwDetails.length > 0) {
              this.getQmsTaskECActionsVwDetails.forEach((actionData: any = []) => {
                if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
                  this.dropDownForActionName.push(actionData);
                }
                this.selectBoxForActionName();
              });
            } else {
              this.dropDownForActionName = [];
              this.selectBoxForActionName();
            }
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
          }
      });
    } else if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Findings") {
      this.appService.getAllAuFindingsByAuNo(this.refNo).subscribe((findings: any) => {
        this.findingsList = findings;
        this.isProcessing = false;
        this.selectBoxForFindings();
      });
    }
  }

  public selectBoxForFindings(): void {
    this.findingsDropdown = this.findingsList?.map((finding: any) => ({
      valueExp: finding.findingId,
      displayExp: finding.findingShortDescription
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onFindingSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('finding', item.valueExp);
      })
    }
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = fieldId == 'business-area';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  refreshForm() {
    this.getcallMethod();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  qmsTasksECDetailsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsTasksECDetailsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsTasksECDetailsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }


  ECPerformer: boolean;
  getcallMethod() {
    this.qmsTasksECDetailsDataForGrid = [];

    const data = {

      gridName: "EC_PARTICIPANT",
      groupId: 0
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = 0;

        const data1: any = {

          gridName: "QMS_TASK_EC_PARTICIPANTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: (response.invisibleColumn ?? '') + (this.qmsservice.moduleName == 'AU' ? ",ACTION_NAME" : ",FINDING_SHORT_DESCRIPTION"),
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          refNoFromEffectivenessCheckDetail: this.refNo,
          ecIdFromECMasterPage: this.message.ecMasterDetails.EC_ID,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsTasksECDetailsDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }

              for (const element of this.qmsTasksECDetailsDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] === 'Y';
                  }
                }
              }

              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              this.labelcall();
            });

            this.ngOnChanges();
            this.message.gridList = this.qmsTasksECDetailsDataForGrid;
            this.collectionSize = this.qmsTasksECDetailsDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsTasksECDetailsDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        return this.dynamicLabel
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  ngOnChanges() {
    if (this.qmsservice.userRole[0].qmsRoles.includes("Effectiveness Check Performer") &&
      (this.effectivenessCheckData.status == 'Planning' || this.effectivenessCheckData.status == 'Approval Rejected')) {
      this.ECPerformer = true;
    } else {
      this.ECPerformer = false;
    }

    this.refresh = false;
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsTasksECDetailsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }


  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  actionNameListDropdown: any = [];
  selectBoxForActionName() {
    this.actionNameListDropdown = [];
    for (const element of this.dropDownForActionName) {
      this.actionNameListDropdown = this.actionNameListDropdown.concat({
        valueExp: element.actionId,
        displayExp: element.actionName
      });
    }
  }

  public onActionsSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('actions-validation', item.valueExp);
      })
    }
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;

  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  searchManagerConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  selectBoxForDesignation() {
    this.designationListDropdown = [];
    for (const element of this.dropDownForDesignation) {
      this.designationListDropdown = this.designationListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    for (const element of this.dropDownForDepartment) {
      this.departmentListDropdown = this.departmentListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  currentIndex: any;
  previousIndex: any = null;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      this.currentIndex = idx;
      if (this.previousIndex == null) {
        this.previousIndex = this.currentIndex;
      } else if (this.previousIndex != this.currentIndex) {
        this.getOneQmsUsersVwDetailsTableData[this.previousIndex].checkedCheckBox = false;
        this.previousIndex = this.currentIndex;
      }

      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }
  draftUser: any = {};
  onChildChecked(e: any, data: any) {
    this.getOneQmsUsersVwDetailsTableData.every((item: any) => { if (item.searchUserChildCheckBox) { item.searchUserChildCheckBox = false; } return true; })

    if (e.target.checked) {
      data.searchUserChildCheckBox = true;
      this.draftUser = data;
    } else {
      data.searchUserChildCheckBox = false;
      this.draftUser = {};
    }
  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByEmail: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  searchManagerFunction() {
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search Participant";
    this.selectedUserCriteria = 'All Quality Users';
    this.previousIndex = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.visibleSearchParticipantPopup = this.dialog.open(this.searchParticipantPopup, this.searchParticipantPopupConfig);
  }

  searchManagerGridDataFunction() {
    let searchByUserName;
    if (this.selectedUserCriteria == 'All Quality Users') {
      this.isProcessing = true;
      if (this.searchByUserName) {
        searchByUserName = this.searchByUserName.toUpperCase();
      } else {
        this.searchByUserName = '';
      }
      this.searchOneQmsUserVwDetails = {
        userName: searchByUserName,
        firstName: this.searchByFirstName,
        lastName: this.searchByLastName,
        emailAddress: this.searchByEmail,
        designationCode: this.searchByDesignationCode,
        departmentCode: this.searchByDepartmentCode,
        module: "QMS" /* Note: module is mandatory in java query. Values can be assigned to module are 'QMS', 'TRN', 'DOCS'... and so on */
      };

      this.appService.getUsersDetailsFromOneQmsUsersWithRoles(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
        this.getOneQmsUsersVwDetailsTableData = response.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
        this.showUserSearchGrid = true;
        this.isProcessing = false;
      })
    } else {
      this.participantUserNameValue = document.getElementById("participant-validation") as HTMLInputElement;
      this.ecParticipantsData.participantUserId = this.selectedGroupUser;
      this.ecParticipantsData.participantUserName = this.selectedGroupUserName;

      if (this.ecParticipantsData.participantUserName == "") {
        this.participantUserNameValue.style.color = 'red';
      } else {
        this.participantUserNameValue.style.color = '';
      }

      this.visibleSearchParticipantPopup.close();
    }
  }


  addManagerNameFunction() {
    this.participantUserNameValue = document.getElementById("participant-validation") as HTMLInputElement;
    this.ecParticipantsData.participantUserId = this.draftUser.userId;
    this.ecParticipantsData.participantUserName = this.draftUser.userName;

    if (this.ecParticipantsData.participantUserName == "") {
      this.participantUserNameValue.style.color = 'red';
    } else {
      this.participantUserNameValue.style.color = '';
    }

    this.visibleSearchParticipantPopup.close();


  }

  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchManagerPopup.close();
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;
  ecParticipantsData: any = {};
  showActionDropdown: boolean = false;
  openAddPopup() {
    this.isProcessing = true;
    this.popupDataTitle.title = "Add Effectiveness Check Participant";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.ecParticipantsData.participantUserName = "";
    this.ecParticipantsData.actionId = '';
    this.showActionDropdown = this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items";

    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.appService.getQmsTaskEcActionVwDetails(this.refNo, this.message.ecMasterDetails.EC_ID).subscribe(
        (data: any) => {
          this.getQmsTaskECActionsVwDetails = data;
          if (this.getQmsTaskECActionsVwDetails.length > 0) {
            this.getQmsTaskECActionsVwDetails.forEach((actionData: any = []) => {
              if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
                this.dropDownForActionName.push(actionData);
              }
              this.selectBoxForActionName();
              this.isProcessing = false;
            });
            this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
          }
        });
    } else {
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      this.isProcessing = false;
    }
  }

  previousDataEcId: any;
  previousDataParticipantId: any;
  getQmsTaskEcParticipantsVwDetailsData: any = [];
  filteredActionValue: any = [];
  openEditPopup(ecParticipantRowData: any) {
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.previousDataEcId = ecParticipantRowData.EC_ID;
    this.previousDataParticipantId = ecParticipantRowData.PARTICIPANT_ID;
    this.popupDataTitle.title = "Edit Effectiveness Check Participant";
    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.showActionDropdown = true;
    } else {
      this.showActionDropdown = false;
    }
    this.isProcessing = true;
    this.appService.getQmsTaskEcParticipantsVwDetailsByOrgIdAndRefNoAndEcIdAndParticipantId(this.refNo, this.previousDataEcId, this.previousDataParticipantId).subscribe((response: any) => {
      this.getQmsTaskEcParticipantsVwDetailsData = response;
      this.ecParticipantsData = response;
      this.ecParticipantsData.participantUserName = this.getQmsTaskEcParticipantsVwDetailsData.transientParticipantUserName;
      this.ecParticipantsData.actionId = this.getQmsTaskEcParticipantsVwDetailsData.actionId;
      this.isProcessing = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })
  }

  cancelAddAndEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  openDeletePopup(ecParticipantRowData: any) {
    this.popupDataTitle.title = "Delete Effectiveness Check Participant";
    this.operationFlag = 'DELETE';
    this.previousDataEcId = ecParticipantRowData.EC_ID;
    this.previousDataParticipantId = ecParticipantRowData.PARTICIPANT_ID;
    this.ecParticipantsData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  actionNameValue: any;
  participantUserNameValue: any;
  fieldValidation() {

    this.actionNameValue = document.getElementById("actions-validation") as HTMLInputElement;
    this.participantUserNameValue = document.getElementById("participant-validation") as HTMLInputElement;

    if (this.ecParticipantsData.participantUserName == "") {
      this.participantUserNameValue.style.color = 'red';
    }

    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" && !this.ecParticipantsData.actionId) {
      this.actionNameValue.style.color = 'red';
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addAndEditFunction(ecParticipantsData: any) {
    if (this.ecParticipantsData.participantUserName == "" || (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" && !ecParticipantsData.actionId)) {
      this.fieldValidation();
      alert("Please enter the all mandatory fields...");
    } else if (this.operationFlag == "ADD") {
      this.isProcessing = true;
      ecParticipantsData.qmsTaskECParticipantsVwPk = {
        ecId: this.message.ecMasterDetails.EC_ID
      }
      ecParticipantsData.participantUserId = this.ecParticipantsData.participantUserId;
      ecParticipantsData.module = this.module;
      ecParticipantsData.refNo = this.refNo;
      if (this.message.ecMasterDetails.CHECK_REQD_FOR != 'Individual Findings') {
        ecParticipantsData.findingId = null;
      }
      this.appService.createQmsTasksECParticipants(ecParticipantsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.isProcessing = true;
      ecParticipantsData.qmsTaskECParticipantsVwPk = {
        ecId: this.message.ecMasterDetails.EC_ID,
        participantId: this.previousDataParticipantId
      }
      ecParticipantsData.participantUserId = this.ecParticipantsData.participantUserId;
      ecParticipantsData.module = this.module;
      ecParticipantsData.refNo = this.refNo;
      if (this.message.ecMasterDetails.CHECK_REQD_FOR != 'Individual Findings') {
        ecParticipantsData.findingId = null;
      }
      this.appService.updateQmsTasksECParticipants(ecParticipantsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  onFieldFocusout() {
    if (this.deleteReasonFieldValue != undefined) {
      if (this.ecParticipantsData.deleteReason == "" || this.ecParticipantsData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.ecParticipantsData.deleteReason == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction(ecParticipantsData: any) {
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.ecParticipantsData.deleteReason == "") {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
    } else {
      this.isProcessing = true;
      ecParticipantsData.qmsTaskECParticipantsVwPk = {
        ecId: this.message.ecMasterDetails.EC_ID,
        participantId: this.previousDataParticipantId
      }
      ecParticipantsData.deleteReason = this.ecParticipantsData.deleteReason;
      this.appService.deleteQmsTasksECParticipants(ecParticipantsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openAuditTrail(viewType: any, extension: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : extension.PARTICIPANT_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'EC_PARTICIPANT';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Effectiveness Check Participants Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(extension);
  }


  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Effectiveness Check Participants Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  @ViewChild('searchParticipantPopup', { static: true }) searchParticipantPopup: TemplateRef<any>;
  visibleSearchParticipantPopup: MatDialogRef<TemplateRef<any>>;

  searchParticipantPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  selectedUserCriteria: any;
  searchCriteriaOptions: any = ['All Quality Users', 'Group Users'];
  designationSearchText: string = '';
  departmentSearchText: string = '';
  groupUserSearchText: string = '';

  dropdownGroupUsers: any = [];
  groupUsersDropdown: any = [];
  selectedGroupUser: any = null;
  onSearchCriteriaChanged(criteria: any) {
    this.reset();

    if (criteria == 'Group Users') {
      this.isProcessing = true;
      this.appService.getQmsActiveUsersByGroupIdModule(this.qmsservice.selectedActivityGroupId, this.qmsservice.moduleName).subscribe(((groupUsers: any) => {
        this.dropdownGroupUsers = groupUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
        this.selectBoxForGroupUsers();
        this.isProcessing = false;
      }))
    }
  }

  selectBoxForGroupUsers() {
    this.groupUsersDropdown = this.dropdownGroupUsers?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    })) || []
  }

  reset() {
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.selectedGroupUserName = '';
    this.selectedGroupUser = null;
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  cancelSearchParticipantPopup() {
    this.visibleSearchParticipantPopup.close();
  }

  selectedGroupUserName: string = '';
  onGroupUserSelect(event: any, user: any) {
    if (event.isUserInput) {
      this.selectedGroupUserName = user.displayExp;
    }
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchParticipant() {
    this.searchUsersComponent.popupTitle = 'Participant';
    this.searchUsersComponent.selectionMode = this.operationFlag == 'ADD' ? 'multiple' : 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    console.log(this.searchUsersComponent.multiUsersArray, 'USER');
    if (this.operationFlag == 'ADD') {
      this.ecParticipantsData.participantUserName = this.searchUsersComponent.multiUsersArray.map((user: any) => user.userName)?.join(',')
    } else {
      this.ecParticipantsData.participantUserName = this.qmsservice.selectedSearchUserName;
      this.ecParticipantsData.participantUserId = this.qmsservice.selectedSearchUserId;
    }
  }

  responses: any[] = [];
  create() {

    if ((this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" && !this.ecParticipantsData.actionId) || !this.ecParticipantsData.participantUserName) {
      this.showSnackBar("Please enter the mandatory fields!", 'E');
      return;
    }

    this.isProcessing = true;
    this.responses = [];
    from(this.searchUsersComponent.multiUsersArray) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((user: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */

          let obj: { [key: string]: any };

          obj = {
            ...this.ecParticipantsData,
            qmsTaskECParticipantsVwPk: {
              ecId: this.message.ecMasterDetails.EC_ID
            },
            participantUserId: user.userId,
            participantUserName: user.userName,
            module: this.module,
            refNo: this.refNo,
            actionId: this.ecParticipantsData.actionId
          }

          return this.appService.createQmsTasksECParticipants(obj).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = { user, response: Response };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(user))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.popupTitle = "EC Participants Creation Results";
          this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;
  resultPopupConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  cancelResultPopup() {
    this.getcallMethod();
    this.ecParticipantsData = {};
    this.visibleResultPopup.close();
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  public focusEmpty(): void { console.log(); }

}
